import emoji from "@/utils/emoji";

function contMatch(data) {
    // var text = ''
    // if (data.type == "text") {
    //     text = data.text
    //     emoji.forEach(function (item) {
    //         if (text.indexOf(item.name) != -1) {
    //             text = text.replaceAll(item.name, '<i class="iconemoji ' + item.icon + '"></i>')
    //         }
    //     })
    // }
    //
    // return text
  if (data.type == "text") {
    var re = /\[([^\]\[]*)\]/g;
    var matches = data.text.match(re) || [];
    for (var j = 0, len = matches.length; j < len; ++j) {
      if(emoji[matches[j]]){
        data.text = data.text.replace(matches[j], '<img style="width: 30px" class="emoji" src="' + require("@/assets/img/emoji/" + emoji[matches[j]] ) + '" />');
      }
    }
  }

  return data.text;
}

export default contMatch
